import classNames from 'classnames/bind';
import { Panel } from 'components/Panel';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadCompanyConfiguration } from 'shared/hooks/use-load-company-configuration';
import { onBoardingActions } from 'store/onBoarding/onBoarding.actions';

import type { StepProps } from '../OnBoarding.types';
import styleIdentifiers from './ColorLogo.module.scss';
import ColorLogoForm from './ColorLogoForm';

const styles = classNames.bind(styleIdentifiers);

export default function ColorLogo({ onValidStep }: StepProps) {
  const { t } = useTranslation();
  const { refetchCompany } = useLoadCompanyConfiguration();

  const onSubmit = (data: any) => {
    data.color = data.color?.hex ? data.color.hex.replace('#', '') : data.color;

    onBoardingActions.companyIdentity({
      data,
      callback: async () => {
        const { error, isError, isSuccess } = await refetchCompany();
        if (isSuccess) onValidStep();
        else if (isError) {
          onValidStep(error.response?.data.next_step);
        }
      },
    });
  };

  return (
    <div className={styles('color-logo')}>
      <div className={styles('steps')}>
        <Panel title={t(i18nKeys.ONBOARDING[4].TITLE)}>
          <ColorLogoForm onSubmit={onSubmit} />
        </Panel>
      </div>
    </div>
  );
}
